<template>
  <div>
    <div v-if="changesTotalCount"
         class="ml-6 mr-6 mt-2 cursor-pointer badge-wrapper"
         @click="onBadgeClick" >
      <v-badge
        :value="changesTotalCount"
        overlap
        bordered
        offset-x="2"
        offset-y="7"
        class=""
      >
        <template v-slot:badge>
          {{ changesTotalCount }}
        </template>
        <v-tooltip bottom v-if="changesTotalCount">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="grey"
              dark
              v-bind="attrs"
              v-on="on"
            >
              mdi-flash
            </v-icon>
          </template>
          <span>{{ $t('changes.tooltip') }}</span>
        </v-tooltip>
      </v-badge>
    </div>
    <v-dialog v-model="dialog" max-width="90%" >
      <template v-slot:default="{  }">
        <v-card class="pa-10">
          <h6 class="mb-6 font-weight-bold text-h6">{{ $t('changes.title') }}</h6>
          <v-data-table
            :headers="tableHeaders"
            :items="changesComputed"
            class="p-no-borders"
            hide-default-footer
          >
            <template v-slot:[`item.userId`]="{ item }">
              <div class="py-6">
                <p-user-item
                  :value="userById(item.userId) || {}"
                  avatar-class="mr-2"
                  avatar-only
                ></p-user-item>
              </div>
            </template>
            <template v-slot:[`item.fields`]="{ item }">
              <ul>
                <li v-for="field in item.fields" :key="`field-${field}`" class="">
                  {{ field }}
                </li>
              </ul>
            </template>
            <template v-slot:[`item.time`]="{ item }">
              <span class="p-projects__date-string">{{ getTime(item.time) }}</span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="p-table-row-actions">
                <PBtnIcon v-if="item.action !== 'Delete'" type="view" @click="changeTenantSeasonProjectAndGoToEntity(item)"></PBtnIcon>
                <PBtnIcon type="delete" @click="removeFromChanges(item)"></PBtnIcon>
              </div>
            </template>
          </v-data-table>
          <div v-if="changesTotalCount">
            <span class="mr-6 mt-6 font-weight-bold text-h6">Delete all these notifications?</span>
            <PBtnIcon type="delete" @click="removeAllChanges"></PBtnIcon>
          </div>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

import vueApp from '@/main'
import eventBus from '@/eventBus'

import dateTimeHelper from '@/helpers/dateTime.helper'

import PUserItem from '@/components/PUserItem'
import PBtnIcon from '@/components/PBtnIcon'

import moment from 'moment'

import { routeNameByParam } from '@/constants'



export default {
  components: {
    PUserItem,
    PBtnIcon
  },


  computed: {
    ...mapGetters('tenant', ['currentTenant']),
    ...mapGetters('season', ['seasonById']),
    ...mapGetters('user', ['currentUserId', 'userById', 'users']),
    ...mapGetters('member', ['memberById']),
    ...mapGetters('project', ['projectById']),
    ...mapGetters('changes', ['changesTotalCount', 'changesArray']),

    changesComputed () {
      return this.changesArray.map(changesItem => {
        return {
          ...changesItem,
          seasonName: changesItem.season?.name ? changesItem.season.name : '-',
          projectTitle: changesItem.project?.title ? changesItem.project.title : '-'
        }
      })
    },

    tableHeaders () {
      return [
        { text: this.$t('changes.table.param'), value: 'param' },
        { text: this.$t('changes.table.text'), value: 'text' },
        { text: this.$t('changes.table.action'), value: 'action' },
        { text: this.$t('changes.table.fields'), value: 'fields' },
        { text: this.$t('changes.table.time'), value: 'time' },
        { text: this.$t('changes.table.user'), value: 'userId' },
        { text: this.$t('changes.table.tenant'), value: 'tenant' },
        { text: this.$t('changes.table.season'), value: 'seasonName' },
        { text: this.$t('changes.table.project'), value: 'projectTitle' },
        { text: '', value: 'actions', align: 'end', sortable: false, filterable: false }
      ]
    }
  },


  data () {
    return {
      dialog: false,
      dateTimeHelper,
      socket: null,
      dataChanged: {},
      params: ['Project', 'Member', 'Budget', 'Event', 'Document', 'Note', 'Contract', 'Schedule', 'Hour', 'Email', 'SMS'],
      actions: ['Update', 'Delete', 'Insert'],
      btn: null,
      tableOptionsProjects: {}
    }
  },


  methods: {
    ...mapActions('changes', ['addToChanges', 'removeFromChanges', 'removeAllChanges']),

    ...mapActions('project', ['loadAndUpdateProject', 'loadProjects', 'loadAllProjects', 'loadProjectByTenantById']),

    ...mapActions('member', ['loadAndUpdateMember', 'loadMembersByProject']),
    ...mapActions('budget', ['loadAndUpdateBudget', 'loadBudgetsByProjectId']),
    ...mapActions('event', ['loadAndUpdateEvent', 'loadEventsByProject']),

    ...mapActions('document', ['loadAndUpdateDocument', 'loadDocuments']),
    ...mapActions('note', ['loadAndUpdateNote', 'loadNotes']),

    ...mapActions('contract', ['loadAndUpdateContract', 'loadContractsByProject']),

    ...mapActions('schedule', ['loadAndUpdateSchedule', 'loadSchedulesByProject']),

    ...mapActions('todo', ['loadAndUpdateTodo', 'loadTodosByProject']),

    ...mapActions('socialMediaPost', ['loadAndUpdatePost', 'loadSocialMediaPostsByProject']),
    ...mapActions('socialMediaChannel', ['loadAndUpdateChannel', 'loadSocialMediaChannels']),

    ...mapActions('sms', ['loadAndUpdateSms', 'loadSms']),

    ...mapActions('contact', ['loadAndUpdateContact', 'loadContactsTableItems']),

    ...mapActions('user', ['loadUsers', 'loadUserById', 'loadAndUpdateUser', 'loadUsers']),

    ...mapActions('season', ['loadAndUpdateSeason', 'loadSeasons']),
    ...mapActions('contractTemplate', ['loadAndUpdateContractTemplate', 'loadContractTemplates']),
    ...mapActions('scheduleTemplate', ['loadAndUpdateScheduleTemplate', 'loadScheduleTemplates']),
    ...mapActions('budgetCategory', ['loadAndUpdateBudgetCategory', 'loadBudgetCategories']),
    ...mapActions('eventCategory', ['loadAndUpdateEventCategory', 'loadEventCategories']),


    async connect () {
      const token = await vueApp.$auth.getTokenSilently()
      this.socket = new WebSocket(`wss://partiturapi-stage.azurewebsites.net/PartiturHub/${this.currentTenant}?access_token=${token}`)
      console.log('Socket is created', this.socket)

      this.socket.onclose = (e) => {
        console.log('Socket is closed. Reconnect will be attempted in 1 second.', e.reason)
        setTimeout(() => {
          this.connect()
        }, 1000)
      }

      this.socket.onerror = (err) => {
        console.error('Socket encountered error: ', err.message, 'Closing socket')
        this.socket.close()
      }

      // eslint-disable-next-line
      const firstMessage = '{"protocol":"json","version":1}'
      this.socket.addEventListener('open', () => {
        console.log('Socket is opened')
        this.socket.send(firstMessage)
      })

      this.socket.addEventListener('message', async (event) => {
        const messageFromServer = event.data
        const startStr = '"Message",'
        const startIndex = messageFromServer.indexOf(startStr)

        if (startIndex !== -1) {
          const jsonStartIndex = startIndex + startStr.length
          const messageFromServerCuttedFromStart = messageFromServer.substr(jsonStartIndex, messageFromServer.length - 1)
          const messageFromServerFinal = messageFromServerCuttedFromStart.substr(0, messageFromServerCuttedFromStart.length - 3)
          this.dataChanged = JSON.parse(messageFromServerFinal)
          this.dataChanged.changedByCurrentUser = this.dataChanged.userId === this.currentUserId

          if (!this.dataChanged.changedByCurrentUser) {
            this.dataChanged.changeId = `${this.dataChanged.entityId}_${this.dataChanged.time}`


            await this.loadUsers()
            // await this.loadAllProjects()

            this.dataChanged.season = null
            this.dataChanged.project = null

            if (this.dataChanged.projectId) {
              this.dataChanged.project = this.projectById(this.dataChanged.projectId)

              if (!this.dataChanged.project) {
                this.dataChanged.project = await this.loadProjectByTenantById({ tenant: this.dataChanged.tenant, id: this.dataChanged.projectId })
              }
            }

            if (this.dataChanged.seasonId) {
              this.dataChanged.season = this.seasonById(this.dataChanged.seasonId)
            } else {
              this.dataChanged.season = this.dataChanged.project ? this.seasonById(this.dataChanged.project.seasonId) : null
            }

            this.dataChanged.routeName = routeNameByParam[this.dataChanged.param]

            switch (this.dataChanged.param) {
              case 'Project':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateProject
                this.dataChanged.loadAllItemsMethod = this.loadProjects
                break
              case 'Member':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateMember
                this.dataChanged.loadAllItemsMethod = this.loadMembersByProject
                break
              case 'Budget':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateBudget
                this.dataChanged.loadAllItemsMethod = this.loadBudgetsByProjectId
                break
              case 'Event':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateEvent
                this.dataChanged.loadAllItemsMethod = this.loadEventsByProject
                break
              case 'Document':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateDocument
                this.dataChanged.loadAllItemsMethod = this.loadDocuments
                break
              case 'Note':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateNote
                this.dataChanged.loadAllItemsMethod = this.loadNotes
                break
              case 'Contract':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateContract
                this.dataChanged.loadAllItemsMethod = this.loadContractsByProject
                break
              case 'Schedule':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateSchedule
                this.dataChanged.loadAllItemsMethod = this.loadSchedulesByProject
                break
              case 'Todo':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateTodo
                this.dataChanged.loadAllItemsMethod = this.loadTodos
                break
              case 'Post':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdatePost
                this.dataChanged.loadAllItemsMethod = this.loadSocialMediaPostsByProject
                break
              case 'Social-account': // todo can not test
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateChannel
                this.dataChanged.loadAllItemsMethod = this.loadSocialMediaPostsByProject
                break
              case 'Email': // todo websocket does not receive any messages for emails @@@
                break
              case 'SMS': // todo check how this works
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateSms
                this.dataChanged.loadAllItemsMethod = this.loadSms
                break
              case 'Contact':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateContact
                this.dataChanged.loadAllItemsMethod = this.loadContactsTableItems
                break
              case 'User':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateUser
                this.dataChanged.loadAllItemsMethod = this.loadUsers
                break
              case 'Season':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateSeason
                this.dataChanged.loadAllItemsMethod = this.loadSeasons
                break
              case 'ContractTemplate':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateContractTemplate
                this.dataChanged.loadAllItemsMethod = this.loadContractTemplates
                break
              case 'ScheduleTemplate':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateScheduleTemplate
                this.dataChanged.loadAllItemsMethod = this.loadScheduleTemplates
                break
              case 'BudgetCategory':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateBudgetCategory
                this.dataChanged.loadAllItemsMethod = this.loadBudgetCategories
                break
              case 'EventCategory':
                this.dataChanged.loadAndUpdateMethod = this.loadAndUpdateEventCategory
                this.dataChanged.loadAllItemsMethod = this.loadEventCategories
                break
              default:
            }


            console.info('*** Step 1 *** after switch - this.dataChanged === ', this.dataChanged)
            this.addToChanges(this.dataChanged)

            switch (this.dataChanged.action) {
              case 'Update':
                await this.onActionUpdate()
                break
              case 'Create':
                await this.onActionCreateOrDelete()
                break
              case 'Delete':
                await this.onActionCreateOrDelete()
                break
              default:
            }
          }
        }
      })

      // config.headers.Authorization = `Bearer ${token}`
      // this.сonnection = new signalR.HubConnectionBuilder()
      //   .withUrl(`wss://partiturapi-stage.azurewebsites.net/PartiturHub/${this.currentTenant}`)
      //   .build()
      // console.info('this.сonnection === ', this.сonnection)
      //
      // this.connection.on('SendToGroup', (project, create, projectId) => {
      //   console.info('project === ', project)
      //   console.info('create === ', create)
      //   console.info('projectId === ', projectId)
      // })
      // this.connection.start().catch((err) => console.Error(err))
    },

    getTime (time) {
      const date = new Date(time)
      return date ? moment(date).format('DD.MM.YYYY HH:mm:ss') : ''
    },

    onBadgeClick () {
      this.dialog = true
    },

    async onActionUpdate () {
      console.info('*** Step 2 *** onActionUpdate ----------->')
      const changedEntity = await this.dataChanged.loadAndUpdateMethod(this.dataChanged)
      console.info('*** Step 2 ***  changedEntity === ', changedEntity)
    },

    async onActionCreateOrDelete () {
      console.info('*** Step 2 *** onActionCreateOrDelete ----------->')
      this.dialog = false
      if (this.dataChanged.param === 'Project') {
        this.initTableOptionsProjects()
      }

      if (this.$router.currentRoute.name === routeNameByParam[this.dataChanged.param]) {
        console.info('*** Step 2 *** onActionCreateOrDelete - emit loadEntities----------->')
        eventBus.$emit('loadEntities')
      }
    },


    changeTenantSeasonProjectAndGoToEntity (item) {
      console.info('ONCLICK *** changeTenantSeasonProjectAndGoToEntity ----------->')
      this.dialog = false
      console.info('changeTenantSeasonProjectAndGoToEntity - emit changeTenantSeasonProject ----------->')
      eventBus.$emit('changeTenantSeasonProject', item)
    },


    initTableOptionsProjects () {
      this.tableOptionsProjects = {
        skip: 0,
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: []
      }
    }
  },


  async created () {
    await this.connect()
  },


  beforeUnmount () {
    this.socket.close()
  }
}
</script>


<style scoped lang="scss">
.badge-wrapper {
  padding: 0;
  border-radius: 50%;
}
</style>
